import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';
import type { ThemeMode as ThemeModeType } from '@visualizer/types';

export type ThemeMode = ThemeModeType;

const sharedOptions: ThemeOptions = {
    typography: {
        fontFamily: `"Lexend", sans-serif`,
        fontSize: 10,
    },

    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    userSelect: 'none',
                },
            },
        },
    },
};

/* 
webapp blue: #5A5AFF
webapp pink: #FF0078

MUI light theme blu: #1976d2
MUI dark theme blu: #90caf9
*/

export const lightTheme = createTheme({
    ...sharedOptions,
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FF0078',
            contrastText: '#ffffff',
        },
        background: {
            default: '#E0E0E0',
            paper: '#F6F5F5',
        },
        text: {
            primary: '#111111',
            secondary: '#4f4f4f',
        },
    },
});

export const darkTheme = createTheme({
    ...sharedOptions,
    palette: {
        mode: 'dark',
        primary: {
            main: '#42a5f5',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FF0078',
            contrastText: '#ffffff',
        },
        background: {
            default: '#404040',
            paper: '#000000',
        },
        text: {
            primary: '#ffffff',
            secondary: '#c5c5c5',
        },
    },
});

export const themes: Record<ThemeMode, Theme> = {
    light: lightTheme,
    dark: darkTheme,
};

export default lightTheme;
